import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="bg-brand-dark text-white py-16 md:py-24 px-4 overflow-hidden" data-id="element-80">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-81">
        {/* Left Column: Copy & CTAs */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="max-w-2xl" data-id="element-82">
          <span className="uppercase tracking-widest text-sm font-bold text-brand-accent mb-4 block" data-id="element-83">
            Lancer Service · St. Paul, MN
          </span>
          <h1 className="font-heading uppercase tracking-wide text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight mb-6" data-id="element-84">
            Your car has changed. Has your shop?
          </h1>
          <div className="text-lg md:text-xl text-gray-300 mb-8 space-y-4" data-id="element-85">
            <p className="font-bold text-white" data-id="element-86">
              Most people have a shop they've used for years. It's familiar,
              it's fine, and it gets the job done. But cars built in the last
              decade are more complex than anything that came before them — and
              a lot of shops are still servicing them the same way they always
              have.
            </p>
            <p data-id="element-87">
              At Lancer Service, our ASE-certified technicians use advanced
              diagnostic tools, manufacturer service data, and a thorough
              42-point inspection process to give you a complete picture of your
              vehicle's health — not just a fix for whatever you came in for.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 mb-6" data-id="element-88">
            <a href="https://www.lancerservice.com/" target="_blank" rel="noopener noreferrer" className="inline-flex justify-center items-center px-8 py-4 bg-brand-accent hover:bg-brand-accentHover text-white font-bold rounded-md transition-colors shadow-lg shadow-brand-accent/20" data-id="element-89">
              Schedule Free Inspection
            </a>
            <a href="#what-we-do" className="inline-flex justify-center items-center px-8 py-4 bg-transparent border-2 border-gray-600 hover:border-gray-400 text-white font-bold rounded-md transition-colors" data-id="element-90">
              See What We Do Differently
            </a>
          </div>

          <div className="text-sm text-gray-400 font-medium" data-id="element-91">
            <p data-id="element-92">Free estimates · Photos & video included</p>
          </div>
        </motion.div>

        {/* Right Column: Image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative lg:pl-12" data-id="element-93">
          <img src="https://cdn.magicpatterns.com/uploads/ttPJFZ4aUyNtMWivQkpBwk/7.5.24Used-0316_Profile_RW_003.jpg" alt="ASE-certified master technician using advanced diagnostic equipment" className="w-full rounded-2xl shadow-2xl shadow-black/40 object-cover aspect-[4/3]" data-id="element-94" />
        </motion.div>
      </div>
    </section>;
}